import React from "react";
import { Chip } from "@material-ui/core";
import HistoryTypeFormatter from "Components/Table/ActionFormatter/HistoryTypeFormatter";
import * as Icons from "react-bootstrap-icons"

export default function HistoryState({ data }) {
    return(
        <div className="project-history">
            <ul>
                {
                    data.map((item, index) => {
                        return (
                            <li key={`${index}-${item.DateRegister}`}>
                                <div>
                                    <HistoryTypeFormatter type={item.Type} />
                                </div>
                                <div>
                                    <span>{item.DateRegister}</span>
                                </div>
                                <div>
                                    <Chip className="primary" label={item.StateName} />
                                </div>
                                <div>
                                    <Icons.JournalText />
                                    <span className={!item.Describ ? 'text-disabled' : ''}>{item.Describ ? item.Describ : 'بدون توضیحات'}</span>
                                </div>
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    )
}